module.exports = __webpack_public_path__ + "static/media/passChange.4f565f1e.svg";